import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from './lib';
import './IconButton.css';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  children: ReactNode;
  dot?: boolean;
};

/* Ref-forwarding so overlays (QrPanel's lightbox) can move focus onto
   their close button the moment they open. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, children, dot, className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      className={cn('mrd-iconbtn', className)}
      {...rest}
    >
      {children}
      {dot && <span className="mrd-iconbtn__dot" />}
    </button>
  );
});
